import { render, staticRenderFns } from "./ClientGroupAndName.vue?vue&type=template&id=1ac3bd6b&scoped=true"
import script from "./ClientGroupAndName.vue?vue&type=script&lang=js"
export * from "./ClientGroupAndName.vue?vue&type=script&lang=js"
import style0 from "./ClientGroupAndName.vue?vue&type=style&index=0&id=1ac3bd6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac3bd6b",
  null
  
)

export default component.exports